export default __webpack_public_path__ + "static/Slide5-757ae86955e54cf88821b6d48884b9bf.png";